import {SystemStatusGroup} from "../../../../gd/const/system-status";
import {TableDefaultAppSettings} from "../../@types";

export const defaultTableSettings : TableDefaultAppSettings = {
    columns                 : _.map(['2','12','4','3','6'], id=>({id: id/*, aggregate: null*/})),
    systemStatusFilter      : SystemStatusGroup.OPEN, // used is task table to show hide archived tasks
    sorting                 : null,  // current sorting value
    filters                 : {},
    areEmptyFoldersHidden   : false
}

export default defaultTableSettings